import { render, staticRenderFns } from "./TrainingForm.vue?vue&type=template&id=0b2b18f2&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b18f2",
  null
  
)

export default component.exports